import toast from "react-hot-toast";

/**
 * Show a toast notification.
 * @param {string} message - Text to display
 * @param {Object} [options] - Optional settings
 * @param {'success'|'error'|'info'|'loading'|'custom'} [options.type='info'] - Toast type
 * @param {number} [options.duration] - Duration in ms (default per type)
 * @param {string} [options.id] - Custom id to update/dismiss later
 * @returns {string} Toast id (for loading: use with toast.success(id) or toast.error(id) to resolve)
 *
 * @example
 * showToast('Saved!', { type: 'success' });
 * showToast('Something went wrong', { type: 'error' });
 * showToast('Please enter a name', { type: 'info', duration: 4000 });
 */
export function showToast(message, options = {}) {
  const { type = "info", duration, id } = options;

  const common = { id, duration };

  switch (type) {
    case "success":
      return toast.success(message, common);
    case "error":
      return toast.error(message, common);
    case "loading":
      return toast.loading(message, common);
    case "custom":
      return toast.custom(message, common);
    case "info":
    default:
      return toast(message, common);
  }
}

export default showToast;
